import qs from 'qs';
import oikosApi from '../../../services/oikos';

export const EQUIPE_CATEG_GR_ID = 2;

export const getEquipeOrcItemFromList = (selOrcItems, orcItemId) => {
  if (!orcItemId) return null;
  return (selOrcItems || []).find((item) => Number(item.value) === Number(orcItemId)) || null;
};

export const isEquipeOrcItem = (orcItem) => Number(orcItem?.categGr_id) === EQUIPE_CATEG_GR_ID;

export const isEquipeOrcItemById = (selOrcItems, orcItemId) => (
  isEquipeOrcItem(getEquipeOrcItemFromList(selOrcItems, orcItemId))
);

export const getEmptyContrFornExtendedFields = () => ({
  contrForn_continuidade: null,
  contrForn_presencaRecorrente: null,
  contrForn_comprovacaoExecucao: null,
  contrForn_modeloCobranca: null,
  contrForn_comprovacaoCobranca: null,
  contrForn_dataPagamento: null,
  contrForn_beneficios: [],
  contrForn_reembolsoDespesas: null,
  contrForn_atenderTerceiros: null,
  contrForn_utilizarEquipePrepostos: null,
  contrForn_contratoAditivoAnterior: null,
});

export const CONTR_FORN_CONTINUIDADE_OPTIONS = [
  { value: 'Contrato contínuo', label: 'Contrato contínuo' },
  { value: 'Por empreitada', label: 'Por empreitada' },
];

export const CONTR_FORN_PRESENCA_RECORRENTE_OPTIONS = [
  { value: 'Não aplicável', label: 'Não aplicável' },
  { value: 'Eventual', label: 'Eventual' },
  { value: 'Até 1 dia', label: 'Até 1 dia' },
  { value: 'Até 2 dias', label: 'Até 2 dias' },
  { value: 'Até 3 dias', label: 'Até 3 dias' },
  { value: 'Conforme projeto', label: 'Conforme projeto' },
];

export const CONTR_FORN_COMPROVACAO_EXECUCAO_OPTIONS = [
  { value: 'Plano mensal', label: 'Plano mensal' },
  { value: 'Relatório mensal', label: 'Relatório mensal' },
  { value: 'Medição', label: 'Medição' },
  { value: 'Aceite', label: 'Aceite' },
  { value: 'Cronograma', label: 'Cronograma' },
];

export const CONTR_FORN_MODELO_COBRANCA_OPTIONS = [
  { value: 'NF', label: 'NF' },
  { value: 'RPA', label: 'RPA' },
  { value: 'Holerite', label: 'Holerite' },
];

export const CONTR_FORN_COMPROVACAO_COBRANCA_OPTIONS = [
  { value: 'Relatório de horas', label: 'Relatório de horas' },
  { value: 'Folha ponto', label: 'Folha ponto' },
  { value: 'Boletim de medição', label: 'Boletim de medição' },
];

export const CONTR_FORN_DATA_PAGAMENTO_OPTIONS = [
  { value: 'Dia 10', label: 'Dia 10' },
  { value: 'Dia 20', label: 'Dia 20' },
  { value: 'Conforme etapa', label: 'Conforme etapa' },
  { value: 'Outra aprovada', label: 'Outra aprovada' },
];

export const CONTR_FORN_BENEFICIOS_OPTIONS = [
  { value: 'Nenhum', label: 'Nenhum' },
  { value: 'Plano odonto', label: 'Plano odonto' },
  { value: 'VT', label: 'VT' },
  { value: 'VR', label: 'VR' },
  { value: 'Auxílio de deslocamento', label: 'Auxílio de deslocamento' },
  { value: 'Auxílio moradia', label: 'Auxílio moradia' },
  { value: 'Totalpass', label: 'Totalpass' },
  { value: 'Universidade corporativa', label: 'Universidade corporativa' },
  { value: 'Todos', label: 'Todos' },
];

export const CONTR_FORN_REEMBOLSO_DESPESAS_OPTIONS = [
  { value: 'Não', label: 'Não' },
  { value: 'Sim mediante aprovação', label: 'Sim mediante aprovação' },
  { value: 'Sim por projeto', label: 'Sim por projeto' },
];

export const CONTR_FORN_ATENDER_TERCEIROS_OPTIONS = [
  { value: 'Sim', label: 'Sim' },
  { value: 'Não com aprovação excepcional', label: 'Não com aprovação excepcional' },
];

export const CONTR_FORN_UTILIZAR_EQUIPE_PREPOSTOS_OPTIONS = [
  { value: 'Sim', label: 'Sim' },
  { value: 'Não', label: 'Não' },
  { value: 'Mediante comunicação', label: 'Mediante comunicação' },
];

export const CONTR_FORN_CONTRATO_ADITIVO_ANTERIOR_OPTIONS = [
  { value: 'Sim', label: 'Sim' },
  { value: 'Não', label: 'Não' },
];

export const parseContrFornBeneficios = (value) => {
  if (!value) return [];
  if (Array.isArray(value)) return value.map((item) => String(item).trim()).filter(Boolean);
  const raw = String(value).trim();
  if (!raw) return [];
  if (raw.startsWith('[')) {
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        return parsed.map((item) => String(item).trim()).filter(Boolean);
      }
    } catch (error) {
      // fallback para split abaixo
    }
  }
  return raw.split(/[;,]/).map((item) => item.trim()).filter(Boolean);
};

export const formatBeneficiosForStorage = (value) => {
  if (!value) return undefined;
  if (Array.isArray(value)) return value.filter(Boolean).join('; ') || undefined;
  return String(value).trim() || undefined;
};

export const parseMultiSelectIds = (value) => {
  if (!value) return [];
  if (Array.isArray(value)) {
    return value.map((item) => Number(item)).filter((id) => Number.isFinite(id) && id > 0);
  }
  const raw = String(value).trim();
  if (!raw) return [];
  if (raw.startsWith('[')) {
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        return parsed.map((item) => Number(item)).filter((id) => Number.isFinite(id) && id > 0);
      }
    } catch (error) {
      // fallback para split abaixo
    }
  }
  return raw
    .split(/[;,]/)
    .map((item) => Number(String(item).trim()))
    .filter((id) => Number.isFinite(id) && id > 0);
};

export const formatMultiSelectIdsForStorage = (value) => {
  const ids = Array.isArray(value) ? parseMultiSelectIds(value) : parseMultiSelectIds(value);
  return ids.length > 0 ? ids.join('; ') : undefined;
};

export const getContrFornDocumentosObrigatoriosIds = (contrFornData = {}) => (
  parseMultiSelectIds(
    contrFornData.contrForn_documentosObrigatorios ?? contrFornData.contrFornDocumentosObrigatorios,
  )
);

export const buildContrFornDocumentosObrigatoriosPayload = (contrFornData = {}, includeField = true) => {
  if (!includeField) return {};

  const documentosObrigatorios = formatMultiSelectIdsForStorage(
    contrFornData.contrForn_documentosObrigatorios ?? contrFornData.contrFornDocumentosObrigatorios,
  );

  return documentosObrigatorios ? { contrForn_documentosObrigatorios: documentosObrigatorios } : {};
};

export const formatDocumentosObrigatoriosLabels = (contrFornData = {}, options = []) => {
  const ids = getContrFornDocumentosObrigatoriosIds(contrFornData);
  if (ids.length === 0) {
    const rawValue = contrFornData.contrForn_documentosObrigatorios
      ?? contrFornData.contrFornDocumentosObrigatorios;
    return rawValue ? String(rawValue).trim() : '-';
  }

  const names = ids
    .map((id) => (options || []).find((option) => Number(option.value) === Number(id))?.label)
    .filter(Boolean);

  return names.length > 0 ? names.join(', ') : ids.join(', ');
};

export const buildDocumentosObrigatoriosMinutaItems = (contrFornData = {}, options = []) => {
  const ids = getContrFornDocumentosObrigatoriosIds(contrFornData);
  if (ids.length === 0) return [];

  return ids.map((id) => {
    const option = (options || []).find((item) => Number(item.value) === Number(id));
    return {
      tpDocumento_id: Number(id),
      tpDocumento_desc: option?.label ? String(option.label) : String(id),
    };
  });
};

/**
 * Garante labels de tpDocumento_desc para o hash do formContratacaoFornecedor.
 * Os ids em contrForn_documentosObrigatorios / vaga_documentosObrigatorios são sempre tpDocumento_id.
 */
export const resolveDocumentosObrigatoriosOptionsForMinuta = async (
  contrFornData = {},
  existingOptions = [],
) => {
  const ids = getContrFornDocumentosObrigatoriosIds(contrFornData);
  if (ids.length === 0) return Array.isArray(existingOptions) ? existingOptions : [];

  const existing = Array.isArray(existingOptions) ? existingOptions : [];

  try {
    const response = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'tpDocumento',
      data: {
        tpDocumento_id: `!IN!(${ids.join(',')})`,
      },
      fields: {
        tpDocumento_id: 'value',
        tpDocumento_desc: 'label',
      },
    })}`);

    const fromTpDocumento = (response?.data || [])
      .map((row) => ({
        value: Number(row.value) || 0,
        label: String(row.label || '').trim(),
      }))
      .filter((row) => row.value > 0 && row.label);

    if (fromTpDocumento.length > 0) {
      const byId = new Map(fromTpDocumento.map((option) => [option.value, option]));
      return ids.map((id) => {
        if (byId.has(id)) return byId.get(id);
        const fallback = existing.find((item) => Number(item.value) === Number(id));
        const label = String(fallback?.label || '').trim();
        return {
          value: id,
          label: (label && label !== String(id)) ? label : String(id),
        };
      });
    }
  } catch (error) {
    console.error('Erro ao resolver labels de tpDocumento para minuta/e-mail:', error);
  }

  return ids.map((id) => {
    const fallback = existing.find((item) => Number(item.value) === Number(id));
    const label = String(fallback?.label || '').trim();
    return {
      value: id,
      label: (label && label !== String(id)) ? label : String(id),
    };
  });
};

const hasCompraCotacaoProprietario = (proprietario) => {
  if (!proprietario) return false;
  try {
    const parsed = typeof proprietario === 'string'
      ? JSON.parse(proprietario)
      : proprietario;
    if (Array.isArray(parsed)) {
      return parsed.map(String).includes('compraCotacao');
    }
  } catch (error) {
    // fallback para string crua
  }
  return String(proprietario).includes('"compraCotacao"')
    || String(proprietario).includes('compraCotacao');
};

/** Options de select de documentos obrigatórios — somente tpDocumento. */
export const fetchDocumentosObrigatoriosTpDocumentoOptions = async () => {
  const response = await oikosApi.get(`/?${qs.stringify({
    action: 'get',
    table: 'tpDocumento',
    data: { tpDocumento_ativo: 1 },
    fields: {
      tpDocumento_id: 'value',
      tpDocumento_desc: 'label',
      tpDocumento_proprietario: 'tpDocumento_proprietario',
    },
    order: 'label',
  })}`);

  return (response?.data || [])
    .filter((row) => hasCompraCotacaoProprietario(row.tpDocumento_proprietario))
    .map((row) => ({
      value: Number(row.value) || row.value,
      label: row.label,
    }));
};

/** Resolve labels a partir de ids (string/array) via tpDocumento. */
export const resolveDocumentosObrigatoriosLabelsFromTpDocumento = async (value) => {
  const ids = parseMultiSelectIds(value);
  if (ids.length === 0) {
    if (value == null || value === '') return null;
    return String(value).trim() || null;
  }

  const options = await resolveDocumentosObrigatoriosOptionsForMinuta(
    { contrForn_documentosObrigatorios: ids },
    [],
  );
  const names = ids
    .map((id) => options.find((option) => Number(option.value) === Number(id))?.label)
    .filter(Boolean);

  return names.length > 0 ? names.join(', ') : ids.join(', ');
};

export const buildContrFornExtendedFieldsPayload = (contrFornData = {}, includeExtendedFields = true) => {
  if (!includeExtendedFields) return {};

  const beneficios = formatBeneficiosForStorage(contrFornData.contrForn_beneficios);

  return {
    contrForn_continuidade: contrFornData.contrForn_continuidade || undefined,
    contrForn_presencaRecorrente: contrFornData.contrForn_presencaRecorrente || undefined,
    contrForn_comprovacaoExecucao: contrFornData.contrForn_comprovacaoExecucao || undefined,
    contrForn_modeloCobranca: contrFornData.contrForn_modeloCobranca || undefined,
    contrForn_comprovacaoCobranca: contrFornData.contrForn_comprovacaoCobranca || undefined,
    contrForn_dataPagamento: contrFornData.contrForn_dataPagamento || undefined,
    contrForn_beneficios: beneficios || undefined,
    contrForn_reembolsoDespesas: contrFornData.contrForn_reembolsoDespesas || undefined,
    contrForn_atenderTerceiros: contrFornData.contrForn_atenderTerceiros || undefined,
    contrForn_utilizarEquipePrepostos: contrFornData.contrForn_utilizarEquipePrepostos || undefined,
    contrForn_contratoAditivoAnterior: contrFornData.contrForn_contratoAditivoAnterior || undefined,
  };
};

const formatPdfText = (value) => (value && String(value).trim() ? String(value).trim() : '-');

const formatPdfYesNo = (active) => (active ? 'Sim' : 'Não');

export const buildContrFornStandardExtraPdfRows = (contrFornData = {}) => {
  const rows = [
    ['Valor global não fixo', formatPdfYesNo(contrFornData.contrForn_vlrFixo === 0)],
    ['Pagamento em dia fixo', formatPdfYesNo(contrFornData.contrForn_dtPgtoFixa === 1)],
    ['Renovação automática', formatPdfYesNo(contrFornData.contrForn_renovacaoAutomatica === 1)],
    ['NF única para todas as parcelas', formatPdfYesNo(contrFornData.contrForn_umaNFParaTodasAsParcela === 1)],
    ['Mão de obra local', formatPdfYesNo(contrFornData.contrForn_maoObraLocal === 0)],
  ];

  if (contrFornData.contrForn_dtPgtoFixa === 1 && contrFornData.contrForn_diaVencPgtos) {
    rows.push(['Dia de vencimento', String(contrFornData.contrForn_diaVencPgtos)]);
  }

  return rows;
};

export const buildContrFornExtendedFieldsPdfRows = (contrFornData = {}) => {
  const beneficios = parseContrFornBeneficios(contrFornData.contrForn_beneficios);

  return [
    ['Continuidade', formatPdfText(contrFornData.contrForn_continuidade)],
    ['Presença recorrente', formatPdfText(contrFornData.contrForn_presencaRecorrente)],
    ['Comprovação da execução', formatPdfText(contrFornData.contrForn_comprovacaoExecucao)],
    ['Modelo de cobrança', formatPdfText(contrFornData.contrForn_modeloCobranca)],
    ['Comprovação da cobrança', formatPdfText(contrFornData.contrForn_comprovacaoCobranca)],
    ['Data de pagamento', formatPdfText(contrFornData.contrForn_dataPagamento)],
    ['Benefícios', beneficios.length > 0 ? beneficios.join(', ') : '-'],
    ['Reembolso de despesas', formatPdfText(contrFornData.contrForn_reembolsoDespesas)],
    ['Prestadora pode atender terceiros', formatPdfText(contrFornData.contrForn_atenderTerceiros)],
    ['Prestadora pode utilizar equipe ou prepostos', formatPdfText(contrFornData.contrForn_utilizarEquipePrepostos)],
    ['Contrato/aditivo anterior', formatPdfText(contrFornData.contrForn_contratoAditivoAnterior)],
  ];
};
